<template>
<b-container class="px-5 py-6 bg-light">
  <b-row class="text-center">
    <b-col cols="12" lg="8" offset-lg="2">
      <slot name="icon">
	<b-img
	  :src="require('../assets/trinity_secure.png')"
	  style="height: 200px;"
	  />
      </slot>
      <div class="my-5">
	<h1>Industrial strength
	  <br><span class="red">Solid Pod</span> by <span class="neon-blue">Graph</span><span class="red">metrix</span>
	</h1>
      </div>
      <p>Solid provides for the first time a single global standardized API</p>
      <p>Solid provides separate places (<q>pods</q>) for you to store your data, a bit like Dropbox and Google Drive and iCloud, but you have the power to share any file or folder or contact or event or whatever with anyone who has a Solid ID.</p>
      <p>When Solid apps start, they just store all the data they need to work in your pod. They don't store the data themselves at some computer run by the person who owns the app. So by default you control all the data in your Solid world. This is a massive improvement to your privacy.</p>
      <p>Solid app builders don't just store the data in your pod any old way. They use Solid standard formats. This means that you and the people you work with can actually use many different apps - at the same time even - to do stuff.</p>
      <slot name="button">
	<div class="d-flex mx-auto my-3 py-5">
	  <b-button
	    size="lg"
	    class="btn-neon-blue mx-auto"
	    href="https://trinpod.us/pricing?industry=productivity"
	    >
	    Get Started
	  </b-button>
	</div>
      </slot>
    </b-col>
  </b-row>
</b-container>
</template>

<script>
export default {
    name: "IndustrialStrengthPod",
    methods: {
	img: function (image) {
	    require(image)
	}
    }
}
</script>
